import React from 'react';
import { CHECKOUT_URL, PURCHASE_ANCHOR } from '../data/content';
interface CTAButtonProps {
  label: string;
  sub?: string;
  target?: 'purchase' | 'checkout';
  className?: string;
}
export function CTAButton({
  label,
  sub,
  target = 'purchase',
  className = ''
}: CTAButtonProps) {
  return <a href={target === 'checkout' ? CHECKOUT_URL : PURCHASE_ANCHOR} className={`block w-full rounded-md border-2 border-gold-dark/40 bg-gold px-3 py-3 text-center font-heading text-[0.86rem] font-black uppercase leading-tight tracking-wide text-navy-deep shadow-cta transition-[filter,transform,box-shadow] duration-150 ease-out-strong hover:brightness-105 active:translate-y-[3px] active:shadow-cta-pressed focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50 sm:text-lg ${className}`} data-id="element-28" data-mp="2fz21wopnf0wk">
      {label}
      {sub ? <span className="mt-0.5 block font-body text-[0.68rem] font-semibold normal-case tracking-normal text-navy-deep/80 sm:text-xs" data-id="element-29" data-mp="3cq406nrdxvth">
          {sub}
        </span> : null}
    </a>;
}